import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { AsyncState } from '../../components/AsyncState.js';
import { TemplateEditor } from '../../components/templates/TemplateEditor.js';
import { getTemplate } from '../../lib/api/templates.js';
import { qk } from '../../lib/query-keys.js';

export const Route = createFileRoute('/_authed/templates/$templateId')({
  component: TemplateEditPage,
});

function TemplateEditPage() {
  const { templateId } = Route.useParams();
  const query = useQuery({
    queryKey: qk.templates.detail(templateId),
    queryFn: () => getTemplate(templateId),
  });

  return (
    <AsyncState query={query}>
      {(template) => (
        <div>
          <h2 className="mb-4 text-xl font-semibold text-neutral-900">Edit template</h2>
          <TemplateEditor template={template} />
        </div>
      )}
    </AsyncState>
  );
}
